import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ag-drivers-view',
  templateUrl: './ag-drivers-view.component.html',
  styleUrls: ['./ag-drivers-view.component.css', '../../../quote.component.css']
})
export class AgDriversViewComponent implements OnInit {
  quote;
  quoteData;
  @Input() set quoteDetails(value: any) {
    if (value) {
      this.quote = value;
      this.quoteData = value.application || value;
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

}
